import { inject, injectable } from 'inversify';
import 'reflect-metadata';

import { ApiGateway, TYPES as ApiGatewayTypes } from '@desygner/ui-core-api-gateway';

import type { CompanyData } from '../../model/company';

export interface ICompanyService {
  fetchCompanyData: () => Promise<CompanyData>;
}

@injectable()
export class CompanyService implements ICompanyService {
  constructor(@inject(ApiGatewayTypes.ApiGateway) private readonly apiGateway: ApiGateway) {}

  public async fetchCompanyData(): Promise<CompanyData> {
    const requestUrl = `brand/companies/${this.apiGateway.company}`;
    const { data: response } = await this.apiGateway.fetch('GET', requestUrl);

    return response as CompanyData;
  }
}
